import { connect, ConnectedProps } from 'react-redux';

import { RootState } from 'store/store';

export const NetworkLoader = ({ display }: NetworkLoaderPropsFromRedux) => {
  return display ? (
    <div className="fixed left-0 top-0 z-[9999] h-[3px] w-full overflow-hidden bg-general-30">
      <div className="absolute size-full animate-networkBar1 bg-primary-100"></div>
      <div className="absolute size-full animate-networkBar2 bg-primary-90"></div>
    </div>
  ) : null;
};

const mapStateToProps = ({ api }: RootState) => ({ display: api.isFetching || false });

const connector = connect(mapStateToProps);

export type NetworkLoaderPropsFromRedux = ConnectedProps<typeof connector>;

export const NetworkLoaderContainer = connect(mapStateToProps)(NetworkLoader);
